import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { BuilderService } from '@scalefast/ecommerce-core';
import { first, map, mergeMap, Observable, ReplaySubject } from 'rxjs';
import { LocalizeHelper } from 'src/app/shared/helpers/localize.helper';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private locale = inject(LOCALE_ID);
  private builderService = inject(BuilderService);
  private campaings$$ = new ReplaySubject<any[]>();

  public campaings$ = this.campaings$$.asObservable();

  constructor() {
    this.getCampains();
  }

  public getGlobalTimer(): Observable<any> {
    return this.campaings$$.pipe(
      map((data) => data.filter((d) => d.allPages)),
      first(),
      mergeMap((d) => d),
    );
  }

  public getTimerById(timerId: string): Observable<any> {
    return this.campaings$$.pipe(
      map((data) => data.filter((d) => d.entryId == timerId)),
      first(),
      mergeMap((d) => d),
    );
  }

  private getCampains(): void {
    this.builderService
      .getContentsByModelName('timer-banner', { sort: { createdDate: -1 } })
      .pipe(
        map((data) => {
          return data.map((value) => {
            const date = LocalizeHelper.getLocaleData(value.data?.timerDate, this.locale);
            return {
              allPages: value.data?.allpages ?? false,
              timerDate: this.getTimerInUtc(date),
              text: value.data?.text,
              entryId: value.data?.entryId,
            };
          });
        }),
      )
      .subscribe((data) => {
        this.campaings$$.next(data);
      });
  }

  private getTimerInUtc(value: Date): Date {
    return new Date(new Date(value).toISOString());
  }
}
